import { executeRequest, Request } from '@jfs/network'
import { getCreateMerchantBody } from '../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigIFSC } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const createMerchantReq = (tokens: any, userAccessToken: string, mid: string, accObj: any) => {
  const body = getCreateMerchantBody(mid, accObj)
  const request: Request<{}> = {
    apiPath: APIEndPoints.createMerchant,
    method: 'POST',
    config: sitConfigIFSC(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: body,
  }
  return executeRequest(request).then((data) => {
    if (data.data.status === 'SUCCESS') {
      return responseParser(data.data)
    } else {
      throw data
    }
  })
}

export { createMerchantReq }
